import type { IUser } from '@futmanager/api-sdk'
import { parseAdminLevel } from '~/utils/admin-level'

/** Normalize login/token payloads so menu ACL always has a usable `level`. */
export function normalizeAdminUser(raw: Partial<IUser> | null | undefined): IUser | undefined {
  if (!raw || raw.user_id == null || raw.login == null)
    return undefined

  const levelSource = raw.level
    ?? (raw as { nivel?: string | number }).nivel
    ?? (raw as { prioridade?: string | number }).prioridade

  return {
    level: parseAdminLevel(levelSource),
    login: String(raw.login),
    name: raw.name ?? null,
    team_id: raw.team_id != null ? String(raw.team_id) : '',
    user_id: String(raw.user_id),
  }
}
